import React from 'react';
import { withTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import '../../css/views/PrivacyLegal.scss';

class LegalStatement extends React.Component {
  render() {
    const { t } = this.props;

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="officialInfo">
          <Typography className="cardTitle" variant="h4" fontFamily="SourceSansPro">
            {t('Legal notice')}
          </Typography>
          <Typography className="cardContents" variant="body2" component="div" fontFamily="SourceSansPro">
            <h2>HILFE UND SUPPORT</h2>
            Falls Sie weitere Unterstützung benötigen, kontaktieren Sie uns über die E-Mail{' '}
            <a href="mailto:amp-support@awesome-technologies.de">amp-support@awesome-technologies.de</a>
            <h2>ANGABEN GEMÄSS § 5 TMG</h2>
            Awesome Technologies Innovationslabor GmbH
            <br /> Kaiserstraße 24<br /> 97070 Würzburg
            <br />
            <br />
            <h2>VERTRETEN DURCH</h2>
            Dr. Cornelia Kolb & Dr. Christoph Günther
            <br />
            <br />
            <h2>KONTAKT</h2>
            Telefon: 0931-306 99 000
            <br />
            E-Mail: info@awesome-technologies.de
            <br />
            <br />
            <h2>REGISTEREINTRAG</h2>
            Eintragung im Handelsregister. <br />
            Registergericht: Amtsgericht Würzburg <br />
            Registernummer: HRB 13771
            <br />
            <br />
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE312916974
            <br />
            <br />
            <h2>VERANTWORTLICH FÜR DEN INHALT NACH § 55 ABS. 2 RSTV</h2>
            Awesome Technologies Innovationslabor GmbH <br />
            Christoph Günther <br />
            Kaiserstraße 24 <br />
            97070 Würzburg
            <br />
            <br />
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
            <br />
            <br />
            <h2>HAFTUNG FÜR INHALTE</h2>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
            Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
            übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf
            eine rechtswidrige Tätigkeit hinweisen.
            <br />
            <br />
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
            bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
            konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
            Inhalte umgehend entfernen.
            <br />
            <br />
            <h2>HAFTUNG FÜR LINKS</h2>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
            Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
            wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
            Zeitpunkt der Verlinkung nicht erkennbar.
            <br />
            <br />
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
            Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
            umgehend entfernen.
            <br />
            <br />
            <h2>URHEBERRECHT</h2>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            <br />
            <br />
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
            beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
            Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            <br />
            <br />
            Quelle: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a>
          </Typography>
        </div>
      </div>
    );
  }
}

export default withTranslation()(LegalStatement);
